
import { Component, Vue, Watch } from 'vue-property-decorator'
import { ReturnPackageListApi } from '@/api/shopOrder'
import { getReturnOrderGoods } from '@/api/industryMall'
import math from '@/core/math'
import { Action, Getter } from 'vuex-class'
import StepperTemp from '@/components/StepperTemp/index.vue'
import { LoginReturnDataDto } from '@/utils/h5ToApp'
@Component({
  name: 'ChoosePackage',
  components: { StepperTemp }
})
export default class ChoosePackage extends Vue {
  @Getter companyId!: string
  @Action setPreReturnOrderParams!: (val) => void
  @Action setReturnOrderList!: (val) => void
  @Getter info: LoginReturnDataDto

  checkedAll = false
  packageList: ReturnPackageListApi[] = []
  totalClass = 0
  totalQuantity = 0
  totalAmount = 0
  checkResult: { [x: string]: any }[] = []
  params: { orderId?: string } = {}

  queryData: { orderId?: string; buyCompanyId?: string; storeId?: string } = {}
  @Watch('packageList', { deep: true })
  changePackageList(val: ReturnPackageListApi[]) {
    console.log('val', val)
    this.checkResult = []
    const { classSum, quantitySum, amountSum } = this.calcSum(val)
    this.totalClass = classSum
    this.totalQuantity = quantitySum
    this.totalAmount = amountSum
    if (val && val.length > 0) {
      val.forEach((item) => {
        if (item.isChecked) {
          this.checkResult.push({
            ...item
            // orderDtlId: item.orderDtlId,
            // returnAmount: item.saleAmount
            // returnAmount: item.returnSaleAmount
          })
        }
      })
    }
    this.checkedAll = this.totalClass === val.length
  }

  handleBack() {
    // debugger
		if (this.$route.query.form === 'detail') {
			this.$router.push({
				path: '/OrderMallDetail',
				query: {
					orderId: this.$route.query.orderId,
          form: 'detail'
				},
			})
		} else {
			// this.$router.back()
      this.$router.push({
				path: '/orderMall',
				query: {
					orderId: this.$route.query.orderId,
          form: 'orderMall'
				},
			})
		}
	}
  get goodsPriceAmount() {
    let price = 0
    const del = this.packageList
    if (del && del.length) {
      price = del.reduce((prev, next: any) => {
        return prev + Number(next.goodsPrice) * next.saleAmount
      }, 0)
    }
    return price
  }

  created() {
    // this.params.currRouteId = this.$route.query.currRouteId as string
    this.params.orderId = this.$route.query.orderId as string
    this.queryData = JSON.parse(JSON.stringify(this.$route.query))
    this.getPackageList()
  }

  getPackageList() {
    // getReturnablePackagesList(this.params).then((res) => {
    getReturnOrderGoods(this.params).then((res) => {
      this.packageList = res.data.del || []
      if (this.packageList && this.packageList.length > 0) {
        this.packageList.forEach((item) => {
          item.isChecked = false
          item.isEdit = false
          item.saleAmount = item.returnSaleAmount
        })
      }
      this.packageList = JSON.parse(JSON.stringify(this.packageList))
    })
  }

  /**
   * 以店铺为单位，计算种类，数量，金额
   * @param packageList 需计算的店铺数据
   */
  calcSum(packageList) {
    // 种类
    let classSum = 0
    // 数量
    let quantitySum = 0
    // 金额
    let amountSum = 0
    // if (packageList && packageList.length > 0) {
    //   packageList.forEach((item: ReturnPackageListApi) => {
    //     if (item.isChecked) {
    //       classSum = Number(math.mathAdd(classSum, 1))
    //       quantitySum = Number(math.mathAdd(quantitySum, item.saleAmount))
    //       if (item.salePrice) {
    //         amountSum = Number(
    //           math.mathAdd(
    //             amountSum,
    //             math.mathMultiply(item.salePrice, item.saleAmount || 0)
    //           )
    //         )
    //       }
    //     }
    //   })
    // }
    // return { classSum, quantitySum, amountSum }
    if (packageList && packageList.length > 0) {
      packageList.forEach((item) => {
        if (item.isChecked) {
          classSum = Number(math.mathAdd(classSum, 1))
          quantitySum = Number(math.mathAdd(quantitySum, item.saleAmount))
          if (item.activityPrice) {
            amountSum = Number(
              math.mathAdd(
                amountSum,
                math.mathMultiply(item.activityPrice, item.saleAmount || 0)
              )
            )
          } else {
            amountSum = Number(
              math.mathAdd(
                amountSum,
                math.mathMultiply(item.goodsPrice, item.saleAmount || 0)
              )
            )
          }
        }
      })
    }
    return { classSum, quantitySum, amountSum }
  }

  /**
   * 切换数量编辑状态
   * @param index 商品套餐下标
   */
  changeEdit(index) {
    this.$set(this.packageList[index], 'isEdit', true)
  }

  handleEmpty() {}

  // 全选
  changeAll() {
    this.packageList.forEach((item) => {
      item.isChecked = this.checkedAll
    })
    this.packageList = JSON.parse(JSON.stringify(this.packageList))
  }

  toSubmitOrder() {
    if (this.checkResult.length <= 0) {
      return this.$toast('请先选择订单')
    }
    console.log('this.ceh', this.checkResult)
    const data = {
      // customerId: this.companyId,
      storeId: this.queryData.storeId,
      buyCompanyId: this.queryData.buyCompanyId,
      orderId: this.params.orderId,
      partnerCompanyId: this.info.partnerCompanyId,
      // currRouteId: this.params.currRouteId,
      returnOrderDtl: this.checkResult.map((item) => ({
        orderDtlId: item.orderDtlId,
        returnAmount: item.saleAmount
      }))
    }
    this.setPreReturnOrderParams(data)
    this.setReturnOrderList(JSON.parse(JSON.stringify(this.checkResult)))
    // 去除中间页
    this.$router.replace({
      path: '/mallSubmitReturnOrder'
    })
  }

  /**
   * 商品数量改变时触发
   * @param index 商品列表下标
   * @param value 选择的商品数量
   */
  changeQuantity(index, value) {
    this.$set(this.packageList[index], 'saleAmount', value)
  }
  /**
   * 商品数量改变时触发
   * @param index 商品列表下标
   * @param value 选择的商品数量
   */
  changeQuantityBlur(index, value) {
    console.log('value', value)
    this.$set(this.packageList[index], 'saleAmount', value)
    this.$set(this.packageList[index], 'isEdit', false)
    console.log('this.packageList[index]', this.packageList[index])
  }
}
